exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".space-card__wrapper[data-v-7939c841]{text-decoration:none;transition:boxShadow .3s ease-in-out}.space-card__wrapper [data-v-7939c841],.space-card__wrapper [data-v-7939c841]:hover,.space-card__wrapper [data-v-7939c841]:visited{text-decoration:none;color:#000}.space-card__wrapper[data-v-7939c841]:hover{transition:boxShadow .3s ease-in-out;box-shadow:2px 2px 8px rgba(0,0,0,.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7939c841","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/organizations/card/spaces/components/SpaceCard.vue
// module id = c687670959d0dd0aa01e
// module chunks = 25